<template>
  <div class="home">
    <div class="content">
      <div class="box">
        <h1 class="title">Welcome to Pokémon Data!</h1>
        <p class="subtitle has-text-grey-light is-size-6">
          A site created to make navigating Pokédex fast.
          <sup>
            <router-link to="/why-pokemon-data">[why]</router-link>
          </sup>
          <br>
        </p>
        <p>Just type to search.</p>
        <img
          src="/images/sylveon-and-eevee-by-arkeis.jpg"
          alt="sylveon and eevee by arkeis"
        >
      </div>

      <div class="has-text-left">
        <div class="columns">
          <div class="column">
            <h5>There's quite a lot to be done, few of the major tasks are:</h5>
            <dl>
              <dt>
                <b-checkbox disabled></b-checkbox>Add items (items list, item page & include in search results)
              </dt>
              <dt>
                <b-checkbox disabled></b-checkbox>Include moves in search results
              </dt>
              <dt>
                <b-checkbox disabled></b-checkbox>Finish evolutions
              </dt>
              <dt>
                <b-checkbox disabled></b-checkbox>Add locations
              </dt>
            </dl>
          </div>
          <div class="column">

          </div>
        </div>
      </div>
      <br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {}
  },
}
</script>
